import React, { useState, useEffect } from "react";

import ApplicantForm from "./components/ApplicantForm";
import VisaHistoryForm from "./components/VisaHistoryForm";
import ArrivalCanadaForm from "./components/ArrivalCanadaForm";
import EducationHistoryForm from "./components/EducationHistoryForm";
import WorkHistoryForm from "./components/WorkHistoryForm";
import TravelHistoryForm from "./components/TravelHistoryForm";
import FamilyInformationForm from "./components/FamilyInformationForm";
import CanadaInformationForm from "./components/CanadaInformationForm";
import ReferenceOtherForm from "./components/ReferenceOtherForm";
import VISAForm from "./components/VISAForm";
import CanadaVisaForm from "./components/CanadaVisaForm";
import FlightForm from "./components/FlightForm";
import EducationForm from "./components/EducationForm";
import WorkForm from "./components/WorkForm";
import TravelForm from "./components/TravelForm";
import AssressHistoryForm from "./components/AssressHistoryForm";
import StatementForm from "./components/StatementForm";
import ChildForm from "./components/ChildForm";
import { onErrorLogout } from "../../_config/authService";
import {
  FaUser,
  FaPhone,
  FaRing,
  FaUserTie,
  FaUserFriends,
  FaUsers,
  FaLandmark,
  FaBalanceScale,
  FaPassport,
  FaFileAlt,
  FaFlag,
  FaPlaneArrival,
  FaGraduationCap,
  FaBriefcase,
  FaGlobe,
  FaHome,
  FaCommentDots,
  FaShieldAlt,
  FaHeartbeat
} from "react-icons/fa";
import { FaChildren } from "react-icons/fa6";

import { makeRequestAuth } from "../../_config/api";
import CriminalitySecurityForm from "./components/CriminalitySecurityForm";
import MedicalHistoryForm from "./components/MedicalHistoryForm";





const Dashboard = () => {
  const [open, setOpen] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [isSpouseApplication, setIsSpouseApplication] = useState(false);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }, []);

  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    try {
      const res = await makeRequestAuth("get", "/user/getProfile");
      if (!res?.data) return;
      console.log('res', res);

      const d = res.data;
      setIsSpouseApplication(d.isSpouseApplication);
    } catch (err) {
      console.error(err);
    }
  };

  const openModal = (card) => {
    setSelectedCard(card);
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
    setSelectedCard(null);
  };

  const cards = [
    {
      title: "BASIC PROFILE",
      desc: "Personal details.",
      icon: <FaUser />,
      component: <ApplicantForm fetchProfileUser={fetchProfile} />,
    },
    {
      title: "CONTACT",
      desc: "Contact details.",
      icon: <FaPhone />,
      component: <VisaHistoryForm />,
    },
    {
      title: "PASSPORT",
      desc: "Passport details.",
      icon: <FaPassport />,
      component: <ReferenceOtherForm />,
    },
    {
      title: "CANADA",
      desc: "Canada-specific information.",
      icon: <FaFlag />,
      component: <CanadaVisaForm />,
    },
    {
      title: "VISA",
      desc: "Visa application details.",
      icon: <FaFileAlt />,
      component: <VISAForm />,
    },
    {
      title: "FLIGHT",
      desc: "Flight booking details.",
      icon: <FaPlaneArrival />,
      component: <FlightForm />,
    },
    {
      title: "MARITAL",
      desc: "Marital details.",
      icon: <FaRing />,
      component: <ArrivalCanadaForm />,
    },

    {
      title: "SPOUSE",
      desc: "Spouse details.",
      icon: <FaUserTie />,
      component: <EducationHistoryForm />,
    },
    {
      title: "CHILD",
      desc: "Child details.",
      icon: <FaChildren />,
      component: <ChildForm />,
    },
    {
      title: "PARENTS",
      desc: "Parents details.",
      icon: <FaUsers />,
      component: <WorkHistoryForm />,
    },
    {
      title: "SIBLINGS",
      desc: "Siblings details.",
      icon: <FaUserFriends />,
      component: <TravelHistoryForm />,
    },
    {
      title: "EDUCATION",
      desc: "Education background.",
      icon: <FaGraduationCap />,
      component: <EducationForm />,
    },
    {
      title: "WORK",
      desc: "Employment history.",
      icon: <FaBriefcase />,
      component: <WorkForm />,
    },
    {
      title: "ADDRESS HISTORY",
      desc: "Previous addresses.",
      icon: <FaHome />,
      component: <AssressHistoryForm />,
    },
    {
      title: "TRAVEL",
      desc: "Travel records.",
      icon: <FaGlobe />,
      component: <TravelForm />,
    },
    {
      title: "CRIMINALITY SECURITY",
      desc: "Declare any criminal records.",
      icon: <FaShieldAlt />,
      component: <CriminalitySecurityForm />,
    },
    {
      title: "MEDICAL HISTORY",
      desc: "Provide your medical details.",
      icon: <FaHeartbeat />,
      component: <MedicalHistoryForm />,
    },
    {
      title: "POLITICAL",
      desc: "Political involvement details.",
      icon: <FaBalanceScale />,
      component: <CanadaInformationForm />,
    },
    {
      title: "LOCAL AUTHORITY",
      desc: "Local authority details.",
      icon: <FaLandmark />,
      component: <FamilyInformationForm />,
    },
    {
      title: "STATEMENT",
      desc: "Declarations & statements.",
      icon: <FaCommentDots />,
      component: <StatementForm />,
    },
  ];


  return (
    <section className="bg-[#132b45] pb-[60px] pt-[150px] md:pt-[200px] md:min-h-screen">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between ">
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-10">
            Trinity file management
          </h1>
          <button type="button" onClick={onErrorLogout} className="mb-6 px-6 py-2 bg-white text-[#132b45] font-semibold rounded-lg shadow-md hover:bg-gray-100 transition">
            Logout
          </button>
        </div>

        {/* 🔲 CARDS GRID */}
        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cards
            .filter((item) => {
              if (item.title === "SPOUSE" && !isSpouseApplication) return false;
              // if (item.title === "MARITAL" && !isSpouseApplication) return false;
              // if (item.title === "CHILD" && !isSpouseApplication) return false;
              // if (item.title === "PARENTS" && !isSpouseApplication) return false;
              // if (item.title === "SIBLINGS" && !isSpouseApplication) return false;
              return true;
            })
            .map((item, index) => (
              <div>
                <div
                  key={index}
                  onClick={() => openModal(item)}
                  className="cursor-pointer bg-white rounded-2xl p-6 shadow-md
              hover:shadow-xl hover:-translate-y-1 transition-all duration-300 group"
                >
                  <div className="flex items-center justify-between mb-4">
                    <h3 className="text-[#132b45] font-bold text-sm md:text-base">
                      {item.title}
                    </h3>
                    <div className="text-xl text-[#132b45] group-hover:scale-110 transition">
                      {item.icon}
                    </div>
                  </div>

                  <p className="text-gray-600 text-sm">{item.desc}</p>
                </div>
              </div>
            ))}
        </div>
      </div>

      {/* 🔥 MODAL */}
      {open && selectedCard && (
        <div className="fixed inset-0 z-[999] flex items-start justify-center bg-black/80 backdrop-blur-sm p-2 md:p-6 overflow-y-auto">

          {/* MT-20 or MT-24 lagane se ye aapke main navigation header ke niche start hoga.
        'h-auto' aur 'min-h-[80vh]' flexible layout ke liye hain.
    */}
          <div className="relative bg-white rounded-xl w-full max-w-6xl my-20 md:my-24 flex flex-col shadow-2xl animate-in fade-in slide-in-from-bottom-4 duration-300">

            {/* 🔒 FIXED HEADER (Modal ka apna header) */}
            <div className="sticky top-0 z-20 bg-white border-b px-6 py-4 flex items-center justify-between rounded-t-xl">
              <div className="flex items-center gap-3">
                <span className="text-xl text-[#132b45]">{selectedCard.icon}</span>
                <h2 className="text-lg md:text-xl font-bold text-[#132b45]">
                  {selectedCard.title}
                </h2>
              </div>

              <button
                onClick={closeModal}
                className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-red-50 text-gray-500 hover:text-red-600 transition-all"
              >
                <span className="text-2xl">✕</span>
              </button>
            </div>

            {/* 🔽 MODAL CONTENT */}
            <div className="p-4 md:p-8 bg-gray-50 rounded-b-xl">
              <div className="max-w-5xl mx-auto bg-white p-5 md:p-10 rounded-lg shadow-sm border">
                {selectedCard.component}
              </div>
            </div>

          </div>
        </div>
      )}
    </section>
  );
};

export default Dashboard;
